import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Modal from "./Modal";
import { toast } from "react-toastify";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setShowServices(false);
  };

  const handleServiceClick = (e, route) => {
    if (!user) {
      e.preventDefault();
      toast.warn("Please login to access this service.");
      setShowLoginModal(true);
    } else {
      closeMenu();
      navigate(route);
    }
  };

  const closeModal = () => setShowLoginModal(false);

  return (
    <>
      <Nav>
        <NavLogo to="/">Passport Assistance Service</NavLogo>

        <BurgerMenu onClick={toggleMenu}>☰</BurgerMenu>

        <NavMenu open={isOpen}>
          <NavItem>
            <NavLink to="/" onClick={closeMenu}>
              Home
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/About" onClick={closeMenu}>
              About
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/EmailForm" onClick={closeMenu}>
              Contact
            </NavLink>
          </NavItem>

          <NavItem>
            <DropdownTrigger onClick={() => setShowServices((prev) => !prev)}>
              Services ▾
            </DropdownTrigger>
            {showServices && (
              <DropdownMenu>
                <DropdownItem
                  to="/ApplyFreshPassport"
                  onClick={(e) => handleServiceClick(e, "/ApplyFreshPassport")}
                >
                  Apply For Fresh Passport Assistance
                </DropdownItem>
                <DropdownItem
                  to="/ApplyReissuePassport"
                  onClick={(e) =>
                    handleServiceClick(e, "/ApplyReissuePassport")
                  }
                >
                  Apply Reissue Passport Assistance
                </DropdownItem>
                <DropdownItem
                  to="/Appointment_Receipt"
                  onClick={(e) => handleServiceClick(e, "/Appointment_Receipt")}
                >
                  Download Appointment Receipt
                </DropdownItem>
                <DropdownItem
                  to="/EnquiryAndDocument"
                  onClick={(e) => handleServiceClick(e, "/EnquiryAndDocument")}
                >
                  Required Document For Passport
                </DropdownItem>
                <DropdownItem
                  to="/NameChanging"
                  onClick={(e) => handleServiceClick(e, "/NameChanging")}
                >
                  Change in Name Assistance
                </DropdownItem>
                <DropdownItem
                  to="/"
                  onClick={(e) => handleServiceClick(e, "/")}
                >
                  Required Document For Visa
                </DropdownItem>
              </DropdownMenu>
            )}
          </NavItem>

          {user ? (
            <>
              <WelcomeText>Welcome, {user.name}</WelcomeText>
              <NavItem>
                <NavLink to="/UserProfile" onClick={closeMenu}>
                  Profile
                </NavLink>
              </NavItem>
              <LoginButton
                as="button"
                onClick={() => {
                  logout();
                  toast.success("Logout successful!");
                  closeMenu();
                }}
              >
                Logout
              </LoginButton>
            </>
          ) : (
            <NavItem>
              <LoginButton to="/Login" onClick={closeMenu}>
                Login →
              </LoginButton>
            </NavItem>
          )}
        </NavMenu>
      </Nav>

      {showLoginModal && (
        <Modal onClose={closeModal}>
          <ModalContent>
            <h3>Access Denied</h3>
            <p>You must be logged in to access these services.</p>
            <ModalButton
              onClick={() => {
                closeModal();
                closeMenu();
                navigate("/Login");
              }}
            >
              Go to Login
            </ModalButton>
            <ModalButton cancel onClick={closeModal}>
              Cancel
            </ModalButton>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default Navbar;

// Styled Components
const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 1000;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  padding: 0rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #dee2e6;
  border-bottom: 1px solid #1f1f21;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.4);
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const NavLogo = styled(Link)`
  color: #dee2e6;
  font-size: 1.5rem;
  font-weight: 600;
  text-decoration: none;
`;

const NavMenu = styled.ul`
  display: flex;
  list-style: none;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    max-height: ${(props) => (props.open ? "600px" : "0")};
    overflow: hidden;
    transition: max-height 0.4s ease;
    gap: 0;
  }
`;

const NavItem = styled.li`
  position: relative;
  width: 100%;

  @media (min-width: 769px) {
    width: auto;
  }
`;

const NavLink = styled(Link)`
  color: #dee2e6;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  display: block;
  padding: 0.75rem 1rem;

  &:hover {
    color: #194bfd;
  }
`;

const DropdownTrigger = styled.span`
  cursor: pointer;
  font-weight: 500;
  display: block;
  padding: 0.75rem 1rem;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 6px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease-in-out;
  z-index: 10;
  width: max-content;

  @media (max-width: 768px) {
    position: static;
    box-shadow: none;
    border: none;
    padding-left: 1rem;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const DropdownItem = styled(Link)`
  padding: 0.75rem 1rem;
  color: #fff;
  text-decoration: none;
  font-size: 0.95rem;
  white-space: nowrap;

  &:hover {
    background-color: #252525;
    color: #00aaff;
  }
`;

const BurgerMenu = styled.div`
  display: none;
  cursor: pointer;
  font-size: 1.5rem;

  @media (max-width: 768px) {
    display: block;
    color: #dee2e6;
  }
`;

const LoginButton = styled(Link)`
  background: linear-gradient(90deg, #194bfd 0%, #ad13fb 100%);
  color: #ffffff;
  padding: 0.6rem 1.5rem;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.85rem;
  margin-left: 1.5rem;
  box-shadow: 0 4px 14px rgba(123, 44, 191, 0.4);
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  display: inline-block;
  margin-top: 0.5rem;

  &:hover {
    background-color: #5a189a;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 5px rgba(90, 24, 154, 0.3);
  }
`;

const WelcomeText = styled.span`
  margin-left: 1rem;
  font-weight: 500;
  color: #00ffae;
  font-size: 0.95rem;
  display: block;
  padding: 0.75rem 1rem;
  white-space: nowrap;

  @media (max-width: 1024px) {
    font-size: 0.9rem;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    text-align: center;
    padding: 0.5rem;
    font-size: 0.85rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    padding: 0.4rem;
  }
`;

const ModalContent = styled.div`
  background: #222;
  padding: 2rem;
  border-radius: 12px;
  color: white;
  max-width: 350px;
  text-align: center;
`;

const ModalButton = styled.button`
  background: ${({ cancel }) => (cancel ? "#555" : "#194bfd")};
  color: white;
  border: none;
  padding: 0.7rem 1.4rem;
  margin: 1rem 0.5rem 0 0.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.25s ease;

  &:hover {
    background: ${({ cancel }) => (cancel ? "#888" : "#4b7fff")};
  }
`;
